"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterfaceArrowUp = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../colors");
const InterfaceArrowUp = () => (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M11.98 19.52L11.98 4.52999", stroke: colors_1.COLORS.BLACK[900], "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    react_1.default.createElement("path", { d: "M5.98798 10.517L12 4.47997L18.012 10.517", stroke: colors_1.COLORS.BLACK[900], "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
exports.InterfaceArrowUp = InterfaceArrowUp;
